import { useMemo } from 'react';
import { getGlobalEData, getLocale } from "../../components/globalE";
import { getDefaultCountry } from "../../countries";
const useFormattedDate = (dateEnd) => {
    return useMemo(() => {
        if (!dateEnd)
            return;
        const globalEData = getGlobalEData();
        const defaultCountry = getDefaultCountry();
        const defaultLocale = getLocale().toLowerCase();
        const countryISO = (globalEData?.countryISO || defaultCountry.code);
        return dateEnd.toLocaleString(`${defaultLocale}-${countryISO}`, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    }, [dateEnd]);
};
export default useFormattedDate;
